import { isBloggerBusiness } from '../../../../../utils/accessService';
import { buildImageSource, buildImageSourceSet } from '../../../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../../../utils/getDomainFromUrl/getDomainFromUrl';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconProduct } from '../../../../icon/IconProduct';
import { Flex } from '../../../../layout/Flex';
import { Image } from '../../../../media/Image';
import { Retry } from '../../../../media/Retry';
import { Typography } from '../../../../typography/Typography';
import { ProductUnavailableLabel } from '../../../ProductUnavailableLabel/ProductUnavailableLabel';
import { ProductMediaCover, ProductTextContainer } from '../../styles';
import type { SingleUnavailableProductCardProps } from './types';

export const SingleUnavailableProductCard = ({
    product,
    businessType,
}: SingleUnavailableProductCardProps) => {
    const t = useTranslation();

    const { content, title } = product;
    const media = content[0]?.media;

    const domain = isBloggerBusiness(businessType)
        ? getDomainFromUrl(product.originalUrl)
        : undefined;

    return (
        <>
            {media ? (
                <ProductMediaCover opacity="0.5">
                    <Flex alignItems="center" justifyContent="center" backgroundColor="white">
                        <Retry>
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(media)}
                                srcSet={buildImageSourceSet(media)}
                            />
                        </Retry>
                    </Flex>
                </ProductMediaCover>
            ) : (
                <ProductMediaCover backgroundColor="white" opacity="0.5">
                    <Flex alignItems="center" justifyContent="center">
                        <IconProduct size={24} color="var(--control-outline-background)" />
                    </Flex>
                </ProductMediaCover>
            )}
            <ProductTextContainer>
                <Typography
                    variant="caption"
                    color="black"
                    opacity={0.5}
                    width="100%"
                    textTransform="none"
                    textAlign="left"
                    lines={domain ? 1 : 2}
                    noWrap={Boolean(domain)}
                >
                    {t(title)}
                </Typography>
                <ProductUnavailableLabel variant="caption2" textTransform="none" mt={0.25} />
                {domain ? (
                    <Typography variant="caption" color="black" textTransform="none" mt={0.25}>
                        {domain}
                    </Typography>
                ) : null}
            </ProductTextContainer>
        </>
    );
};
